import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  Box,
  Tooltip,
} from "@mui/material";
import { Stack } from "@mui/system";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import CancelIcon from "@mui/icons-material/Cancel";
import { formatRefLabel } from "../utils/HelperFunction/textFormatting";

const StatuteContentDialog = ({ open, onClose, label, content, isMobile }) => {
  const [fullscreen, setFullscreen] = useState(false);

  const handleFullscreenToggle = () => setFullscreen((prev) => !prev);

  const contentWithStyles = `
    <style>
      .Section1 * {
        font-family: 'Roboto', Helvetica, Arial, sans-serif !important;
      }
      .Section1 b {
        color: #303f9f;
      }
    </style>
    ${content || ""}
  `;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile || fullscreen}
    >
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          mx: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "16px", md: "18px" },
            color: "#303f9f",
            fontWeight: "bold",
          }}
        >
          {formatRefLabel(label)}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Tooltip title="Full Screen">
            <IconButton onClick={handleFullscreenToggle}>
              {fullscreen ? (
                <FullscreenExitIcon sx={{ color: "#36454f" }} />
              ) : (
                <FullscreenIcon sx={{ color: "#36454f" }} />
              )}
            </IconButton>
          </Tooltip>
          <IconButton edge="end" color="inherit" onClick={onClose}>
            <CancelIcon color="error" />
          </IconButton>
        </Box>
      </Stack>
      <DialogContent dividers>
        <Typography
          variant="subtitle2"
          sx={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif !important",
            "& p": { margin: 0 },
            "& h1": { fontFamily: "Roboto, Arial, sans-serif", margin: "16px 0" },
            "& i": { fontStyle: "italic" },
            "& a": { color: "#303f9f", textDecoration: "none" },
          }}
          component="div"
          dangerouslySetInnerHTML={{ __html: contentWithStyles }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default StatuteContentDialog;
